import { useState } from 'react';

export default function usePageOpenDuration() {
  const [startedAt, setStartedAt] = useState(new Date());

  function getPageOpenDuration() {
    return (new Date().getTime() - startedAt.getTime()) / 1000;
  }

  return { startedAt, setStartedAt, getPageOpenDuration };
}
